import { ILookupHttpService, RemoteParams, LookupGridResult } from '@farris/ui-lookup';
import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FormFormatService implements ILookupHttpService {
    constructor(
        private http: HttpService,
    ) {
    }
    getData(url: string, params?: RemoteParams): Observable<LookupGridResult> {
        const customData = params.customData;
        const index = params.pageIndex || 1;
        const size = params.pageSize || 20;
        const searchValue = JSON.parse(params.searchValue);
        const terminal = customData.tab === 'web' ? 'PC' : 'Mobile';
        let query = '?param=';
        let filter = `{"terminal":"${terminal}"`;
        if (searchValue.searchValue) {
            if (searchValue.searchField === '*') {
                filter += `,"allColumns":"${searchValue.searchValue}"`;
            } else {
                filter += `,"${searchValue.searchField}":"${searchValue.searchValue}"`;
            }
        }
        filter += '}';
        filter = encodeURIComponent(filter);
        query += (filter + `&pageNum=${index}&pageSize=${size}`);
        url += query;
        return this.http.get(url).pipe(
            map((re: any) => ({
                items: re.content,
                total: re.totalElements,
                pageInfo: {
                    pageIndex: re.pageable.pageNumber + 1,
                    pageSize: re.pageable.pageSize,
                    pageList: [20, 40, 60, 80, 100],
                    enablePager: true
                }
            }))
        );
    }
}

